module.exports = __webpack_public_path__ + "assets/img/mr7.e5d5d334.png";